import { baseApi } from "../baseApi";

const PAYMENT_ACCOUNT_BASE_URL = "payment-accounts";

export const paymentAccountApi = baseApi.injectEndpoints({
  tagTypes: ["PaymentAccount"],

  endpoints: (build) => ({
    createPaymentAccount: build.mutation({
      query: (body) => ({
        url: PAYMENT_ACCOUNT_BASE_URL,
        method: "POST",
        body,
      }),
    }),

    listPaymentAccount: build.query({
      query: (params) => ({
        url: PAYMENT_ACCOUNT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "PaymentAccount",
                _id,
              })),
              { type: "PaymentAccount", id: "LIST" },
            ]
          : [{ type: "PaymentAccount", id: "LIST" }],
    }),

    getPaymentAccountDetail: build.query({
      query: (id) => `${PAYMENT_ACCOUNT_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "PaymentAccount", id },
        { type: "PaymentAccount", id: "LIST" },
      ],
    }),

    updatePaymentAccount: build.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${PAYMENT_ACCOUNT_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "PaymentAccount", _id },
        { type: "PaymentAccount", id: "LIST" },
      ],
    }),
    getPaymentAccountDDL: build.query({
      query: (params) => {
        return { url: `${PAYMENT_ACCOUNT_BASE_URL}/ddl`, params };
      },
    }),
    getVendorPaymentAccount: build.query({
      query: ({ vendorId, ...params }) => {
        return {
          url: `${PAYMENT_ACCOUNT_BASE_URL}/vendor/${vendorId}`,
          params,
        };
      },
    }),
    getContractorPaymentAccount: build.query({
      query: ({ contractorId, ...params }) => {
        return {
          url: `${PAYMENT_ACCOUNT_BASE_URL}/contractor/${contractorId}`,
          params,
        };
      },
    }),
    getCustomerPaymentAccount: build.query({
      query: ({ customerId, ...params }) => {
        return {
          url: `${PAYMENT_ACCOUNT_BASE_URL}/customer/${customerId}`,
          params,
        };
      },
    }),
  }),
});

export const {
  useCreatePaymentAccountMutation,

  useLazyListPaymentAccountQuery,

  usePaymentAccountDetailQuery,

  useUpdatePaymentAccountMutation,

  useGetPaymentAccountDetailQuery,

  useLazyGetPaymentAccountDDLQuery,

  useLazyGetVendorPaymentAccountQuery,
  useLazyGetContractorPaymentAccountQuery,
  useLazyGetCustomerPaymentAccountQuery,
} = paymentAccountApi;
